var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},_vm._l((_vm.list),function(item){return _c('div',{key:item.title,staticClass:"item"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(item.title)+" ")]),_c('div',[_c('span',{staticClass:"value"},[_vm._v(_vm._s(item.value))]),_c('span',{staticClass:"unit"},[_vm._v(_vm._s(item.unit))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }